import type {
  AgentFeedOption,
  TrendFeedBannerAgent,
} from 'features/trend-detection/types'

/**
 * True when the API hides feed rows because the selected agent (or the only
 * visible agent) has a run in progress, so empty lists should not imply
 * "no issues exist" — results will return after the run completes.
 */
export function isFeedSuppressedWhileAgentRunning(
  filterAgentUuid: string | null,
  bannerAgents: TrendFeedBannerAgent[],
  agentsForFilter: AgentFeedOption[],
): boolean {
  const runningUuids = new Set(
    bannerAgents.filter((b) => b.status === 'running').map((b) => b.agent_uuid),
  )
  if (runningUuids.size === 0) {
    return false
  }
  if (filterAgentUuid !== null) {
    return runningUuids.has(filterAgentUuid)
  }
  const [onlyAgent] = agentsForFilter
  return (
    agentsForFilter.length === 1 &&
    onlyAgent !== undefined &&
    runningUuids.has(onlyAgent.uuid)
  )
}
